<section>
  <p-confirmDialog [baseZIndex]="10000" key="positionDialog" [position]="dialogPosition"
    rejectButtonStyleClass="p-button-outlined"></p-confirmDialog>
  <div class="container-fluid">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">Home</li>
      <li class="breadcrumb-item">Vendors</li>
      <li class="breadcrumb-item active">Rate Change Request</li>
    </ol>
  </div>
</section>
<section>
  <div class="container-fluid">
    <div class="row mb-2">
      <div class="col-sm-12 p-0">
        <div class="card Title-bar-blue">
          <div class="devcare-card-header">
            <span class="devcare-sub-header Title-bar-text"><i class="fas fa-search mr-1"></i> Rate Change
              Request</span>
            &nbsp;&nbsp;
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<p-confirmDialog [baseZIndex]="10000" rejectButtonStyleClass="p-button-text"></p-confirmDialog>
<section>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="devcare-card-body">
          <div class="row">
            <div class="col-md-4">
              <button [ngClass]="showSorting === true ? 'p-button-raised m-2' : 'p-button-outlined m-2'" pButton
                type="button" icon="pi pi-fw pi-sort-alt" (click)="bindShowSorting()" [loading]="isSearchLoading"
                style="float: left;height: 30px;"></button>

              <button [ngClass]="showFilters === true ? 'p-button-raised m-2' : 'p-button-outlined m-2'" pButton
                type="button" icon="fas fa-filter" (click)="bindShowFilter()" [loading]="isSearchLoading"
                style="float: left;height: 30px;"></button>

              <button [ngClass]="showToggle === true ? 'p-button-raised m-2' : 'p-button-outlined m-2'" pButton
                type="button" icon="pi pi-list" (click)="bindShowToggle()" [loading]="isSearchLoading"
                style="float: left;height: 30px;"></button>

            </div>
            <div class="col-md-8">

              <!-- <button pButton label="Export" (click)="exportVendorClients()" *ngIf="sharedService.checkPermission('Admin_Export')" class="p-button-raised  m-2" icon="pi pi-file-excel" type="button" style="float: right;height: 30px;"
                           ></button> -->

              <button pButton label="Clear" class="p-button-raised m-2" icon="pi pi-filter-slash"
                (click)="clearFilter(dt2)" style="float: right;height: 30px;"></button>

              <!-- <button class="p-button-raised m-2" label ="Apply" pButton type="button" icon="pi pi-filter" (click)="applyFilter()"
                          [loading]="isSearchLoading" style="float: right;height: 30px;"></button> -->


            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section>
  <div class="row">
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <!-- <div class="devcare-table-card-header">
                            <div class="row">
                                <div class="col-md-6">
                                    <button pButton type="button" class="p-button-raised p-button-sm m-2" label="Add"
                                    icon="pi pi-plus" (click)="addVcaDetails()" *ngIf="(isVcaAdd === false) && sharedService.checkPermission('Admin_Add')"></button>
                                </div>
                                <div class="col-md-6">
                                   
                                </div>
                            </div>
                        </div> -->
            <div class="card-header">
              <div class="row">
                <div class="col-md-6">
                  <span class="p-buttonset">
                    <button pButton (click)="approve()" pRipple label="Approve"
                      [disabled]="(selectRateChangeRequestList.length<=0)" icon="pi pi-check-circle"
                      [style]="{height:'30px'}" style="background-color: #82C836;"></button>&nbsp;
                    <button pButton pRipple [disabled]="(selectRateChangeRequestList.length<=0)" (click)="reject()"
                      label="Reject" icon="pi pi-times-circle" [style]="{height:'30px'}"
                      style="background-color: #C00001;"></button>&nbsp;
                  </span>
                </div>
                <div class="col-md-6" *ngIf="showToggle">
                  <p-multiSelect *ngIf="showToggle" [options]="allColumns" [(ngModel)]="selectedColumns"
                    maxSelectedLabels="0" dropdownIcon="pi pi-list" selectedItemsLabel="{0} columns selected"
                    optionLabel="header" [showHeader]="false" [showClear]="false" (onChange)="showAndHideColumn($event)"
                    style="float: right;">
                    <ng-template let-column pTemplate="item">
                      <div class="column-item">
                        <div>{{column.header}}</div>
                      </div>
                    </ng-template>
                  </p-multiSelect>
                </div>
              </div>
            </div>
            <div class="card-body devcare-table-card-body" style="overflow: hidden;">
              <p-table #dt2 [value]="rateChangeRequestList" [lazy]="true" paginatorDropdownAppendTo="body"
                (onLazyLoad)="loadAllApplicantRateChangeRequest($event)" dataKey="id" [rows]="10"
                [showCurrentPageReport]="true" [resizableColumns]="true" columnResizeMode="expand"
                [rowsPerPageOptions]="[10,25,50]" [loading]="loading" styleClass="p-datatable-gridlines"
                [paginator]="isshowpaginator" [totalRecords]="totalRecords"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                [globalFilterFields]="[ 'applicantName','vendorCompanyName','createdByName', 'createdOn','modifieddBy', 'modifiedOn']">
                <!-- <ng-template pTemplate="colgroup" let-columns>
                                    <colgroup>
                                        <col>
                                        <col>
                                        <col>
                                        <col>
                                        <col>
                                        <col>
                                        <col>
                                        <col>
                                        <col>
                                        <col>
                                        <col>
                                        <col>
                                    </colgroup>
                                </ng-template> -->
                <ng-template pTemplate="header">
                  <tr>
                    <th pResizableColumn style="width: 5rem" *ngIf="isShowColumns('action')" [ngStyle]="{'width':setColumnWidth(3)}">Action</th>
                    <th pResizableColumn style="width: 3rem" *ngIf="isShowColumns('checkbox')">
                      <p-checkbox #headerCheckbok binary="true" [(ngModel)]="isheaderCheckbokChecked"
                        (onChange)="selectAllRow(headerCheckbok)"></p-checkbox>
                    </th>
                    <th pResizableColumn style="width: 8rem" *ngIf="isShowColumns('applicantName')" [ngStyle]="{'width':setColumnWidth(6)}">Applicant <span
                        pSortableColumn="applicantName" *ngIf="showSorting">
                        <p-sortIcon field="applicantName"></p-sortIcon>
                      </span>
                      <p-columnFilter [hidden]="!showFilters" type="text" field="applicantName" display="menu"
                        #filterapplicantName [showAddButton]="false" [showOperator]="false"
                        [matchModeOptions]="matchModeOptions" [showClearButton]="false" [showApplyButton]="false">
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                          <input #applicantName type="text" value="{{filters?.applicantName[0]?.value}}" pInputText
                            class="pinputHeight">
                          <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                            <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger"
                              (onClick)="filter(undefined);applyFilterNew(dt2)">Clear</p-button>
                            <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-success"
                              (onClick)="filter(applicantName.value);applyFilterNew(dt2);filterapplicantName.hide()">
                              Apply</p-button>
                          </div>
                        </ng-template>
                      </p-columnFilter>
                    </th>
                    <th pResizableColumn style="width: 8rem" *ngIf="isShowColumns('vendorCompanyName')" [ngStyle]="{'width':setColumnWidth(6)}">Vendor <span
                        pSortableColumn="vendorCompanyName" *ngIf="showSorting">
                        <p-sortIcon field="vendorCompanyName"></p-sortIcon>
                      </span>
                      <p-columnFilter [hidden]="!showFilters" type="text" field="vendorCompanyName" display="menu"
                        #filterVendorCompanyName [showAddButton]="false" [showOperator]="false"
                        [matchModeOptions]="matchModeOptions" [showClearButton]="false" [showApplyButton]="false">
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                          <input #vendorCompanyName type="text" value="{{filters?.vendorCompanyName[0]?.value}}"
                            pInputText class="pinputHeight">
                          <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                            <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger"
                              (onClick)="filter(undefined);applyFilterNew(dt2)">Clear</p-button>
                            <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-success"
                              (onClick)="filter(vendorCompanyName.value);applyFilterNew(dt2);filterVendorCompanyName.hide()">
                              Apply</p-button>
                          </div>
                        </ng-template>
                      </p-columnFilter>
                    </th>
                    <th pResizableColumn style="width: 8rem" *ngIf="isShowColumns('clientCompanyName')" [ngStyle]="{'width':setColumnWidth(6)}">Client <span
                      pSortableColumn="clientCompanyName" *ngIf="showSorting">
                      <p-sortIcon field="clientCompanyName"></p-sortIcon>
                    </span>
                    <p-columnFilter [hidden]="!showFilters" type="text" field="clientCompanyName" display="menu"
                      #filterClientCompanyName [showAddButton]="false" [showOperator]="false"
                      [matchModeOptions]="matchModeOptions" [showClearButton]="false" [showApplyButton]="false">
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <input #clientCompanyName type="text" value="{{filters?.clientCompanyName[0]?.value}}"
                          pInputText class="pinputHeight">
                        <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                          <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger"
                            (onClick)="filter(undefined);applyFilterNew(dt2)">Clear</p-button>
                          <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-success"
                            (onClick)="filter(clientCompanyName.value);applyFilterNew(dt2);filterClientCompanyName.hide()">
                            Apply</p-button>
                        </div>
                      </ng-template>
                    </p-columnFilter>
                  </th>
                    <th pResizableColumn *ngIf="isShowColumns('currentBillRate')" [ngStyle]="{'width':setColumnWidth(6)}">New Rate <span
                        pSortableColumn="currentBillRate" *ngIf="showSorting">
                        <p-sortIcon field="currentBillRate"></p-sortIcon>
                      </span>
                      <p-columnFilter [hidden]="!showFilters"  type="numeric" field="currentBillRate" display="menu" #filtercurrentBillRate
                        [showAddButton]="false" [showMatchModes]="true" [matchModeOptions]="matchModeOptionsForNumeric"
                        [showOperator]="false" [showClearButton]="false" [showApplyButton]="false">
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                          <input #currentBillRate type="number" value="{{filters?.currentBillRate[0]?.value}}" pInputText
                            class="pinputHeight">
                          <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                            <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger"
                              (onClick)="filter(undefined);applyFilterNew(dt2)">Clear</p-button>
                            <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-success"
                              (onClick)="filter(currentBillRate.value);applyFilterNew(dt2);filtercurrentBillRate.hide()">
                              Apply
                            </p-button>
                          </div>
                        </ng-template>
                      </p-columnFilter>
                    </th>

                    <th pResizableColumn *ngIf="isShowColumns('startDateCurrentBillRate')" [ngStyle]="{'width':setColumnWidth(8)}">Start Date <br /> of New Rate <span
                        pSortableColumn="startDateCurrentBillRate" *ngIf="showSorting">
                        <p-sortIcon field="startDateCurrentBillRate"></p-sortIcon>
                      </span>
                      <p-columnFilter [hidden]="!showFilters" type="date" field="startDateCurrentBillRate"
                        display="menu" #filterstartDateNewBillRate [showAddButton]="showAddRuleButtonSNR"
                        [showOperator]="false" [matchModeOptions]="matchModeOptionsForDate" [showClearButton]="false"
                        [showApplyButton]="false">
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                          <p-calendar #startDateCurrentBillRate inputId="navigators" inputId="navigators" [monthNavigator]="true" [yearNavigator]="true"  yearRange="2000:2030" [ngModel]="value"></p-calendar>
                          <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                            <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger"
                              (onClick)="filter(undefined);applyFilterNew(dt2)">Clear</p-button>
                            <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-success"
                              (onClick)="filter(startDateCurrentBillRate.value);applyFilterNew(dt2);filterstartDateNewBillRate.hide()">
                              Apply</p-button>
                          </div>
                        </ng-template>
                      </p-columnFilter>
                    </th>
                    <th pResizableColumn *ngIf="isShowColumns('serviceAgreementDate')" [ngStyle]="{'width':setColumnWidth(8)}">Service Agreement <br /> Date <span
                      pSortableColumn="serviceAgreementDate" *ngIf="showSorting">
                      <p-sortIcon field="serviceAgreementDate"></p-sortIcon>
                    </span>
                    <p-columnFilter [hidden]="!showFilters" type="date" field="serviceAgreementDate"
                      display="menu" #filterserviceAgreementDate [showAddButton]="showAddRuleButtonSAD"
                      [showOperator]="false" [matchModeOptions]="matchModeOptionsForDate" [showClearButton]="false"
                      [showApplyButton]="false">
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-calendar #serviceAgreementDate inputId="navigators" [monthNavigator]="true" [yearNavigator]="true"  yearRange="2000:2030" [ngModel]="value"></p-calendar>
                        <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                          <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger"
                            (onClick)="filter(undefined);applyFilterNew(dt2)">Clear</p-button>
                          <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-success"
                            (onClick)="filter(serviceAgreementDate.value);applyFilterNew(dt2);filterserviceAgreementDate.hide()">
                            Apply</p-button>
                        </div>
                      </ng-template>
                    </p-columnFilter>
                  </th>
                  <th pResizableColumn [ngStyle]="{'width':setColumnWidth(6)}"
                  *ngIf="isShowColumns('po')">PO
                  <p-columnFilter [hidden]="!showFilters" type="text" field="po" display="menu" #filterPo
                      [showAddButton]="false" [showOperator]="false" [showClearButton]="false"
                      [showApplyButton]="false" [matchModeOptions]="matchModeOptionsForDropdown">
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                          <p-dropdown #poStatus [options]="documentSearchValues"
                              [(ngModel)]="selectedPOStatusId"
                              (onChange)="getPOStatusOnChange($event)">
                          </p-dropdown>
                          <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                              <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger"
                                  (onClick)="clearPOStatus();filter(null);applyFilterNew(dt2);">Clear
                              </p-button>
                              <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-success"
                                  (onClick)="filter(poStatus.value);applyFilterNew(dt2);filterPo.hide()">Apply
                              </p-button>
                          </div>
                      </ng-template>
                  </p-columnFilter>
              </th>
                  <th pResizableColumn [ngStyle]="{'width':setColumnWidth(6)}"
                  *ngIf="isShowColumns('msa')">MSA
                  <p-columnFilter [hidden]="!showFilters" type="text" field="msa" display="menu" #filterMsa
                      [showAddButton]="false" [showOperator]="false" [showClearButton]="false"
                      [showApplyButton]="false" [matchModeOptions]="matchModeOptionsForDropdown">
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                          <p-dropdown #msaStatus [options]="documentSearchValues"
                              [(ngModel)]="selectedMSAStatusId"
                              (onChange)="getMSAStatusOnChange($event)">
                          </p-dropdown>
                          <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                              <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger"
                                  (onClick)="clearMSAStatus();filter(null);applyFilterNew(dt2);">Clear
                              </p-button>
                              <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-success"
                                  (onClick)="filter(msaStatus.value);applyFilterNew(dt2);filterMsa.hide()">Apply
                              </p-button>
                          </div>
                      </ng-template>
                  </p-columnFilter>
              </th>
                    <th pResizableColumn *ngIf="isShowColumns('approvalStatusName')" [ngStyle]="{'width':setColumnWidth(9)}">
                      Rate Approval <br /> Status <span pSortableColumn="approvalStatusName" *ngIf="showSorting">
                        <p-sortIcon field="approvalStatusName"></p-sortIcon>
                      </span>
                      <p-columnFilter [hidden]="!showFilters" type="text" field="approvalStatusName" display="menu"
                        #filterStatusName [showAddButton]="false" [showOperator]="false" [showClearButton]="false"
                        [matchModeOptions]="matchModeOptionsForDropdown" [showApplyButton]="false">
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                          <p-dropdown #approvalStatusName [options]="rateChangeStatus" optionLabel="description" 
                            [(ngModel)]="selectedRateChangeStatus"
                            (onChange)="filter($event.value.description);getStatusOnChange($event)">
                          </p-dropdown>
                          <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                            <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger"
                              (onClick)="clearRateApprovalStatus();filter(null);applyFilterNew(dt2)">Clear</p-button>
                            <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-success"
                              (onClick)="filter(approvalStatusName.value);applyFilterNew(dt2);filterStatusName.hide()">
                              Apply</p-button>
                          </div>
                        </ng-template>
                      </p-columnFilter>
                    </th>



                    <th pResizableColumn *ngIf="isShowColumns('oldBillRate')" [ngStyle]="{'width':setColumnWidth(7)}">Current Rate <span
                        pSortableColumn="oldBillRate" *ngIf="showSorting">
                        <p-sortIcon field="oldBillRate"></p-sortIcon>
                      </span>
                      <p-columnFilter [hidden]="!showFilters" type="numeric" field="oldBillRate" display="menu" #filterOldBillRate
                        [showAddButton]="false" [showMatchModes]="true" [matchModeOptions]="matchModeOptionsForNumeric"
                        [showOperator]="false" [showClearButton]="false" [showApplyButton]="false">
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                          <input #oldBillRate type="number" value="{{filters?.oldBillRate[0]?.value}}" pInputText
                            class="pinputHeight">
                          <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                            <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger"
                              (onClick)="filter(undefined);applyFilterNew(dt2)">Clear</p-button>
                            <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-success"
                              (onClick)="filter(oldBillRate.value);applyFilterNew(dt2);filterOldBillRate.hide()">
                              Apply</p-button>
                          </div>
                        </ng-template>
                      </p-columnFilter>
                    </th>
                    <th pResizableColumn *ngIf="isShowColumns('startDateOldBillRate')" [ngStyle]="{'width':setColumnWidth(9)}">Start Date of <br /> Current Rate
                      <span pSortableColumn="startDateOldBillRate" *ngIf="showSorting">
                        <p-sortIcon field="startDateOldBillRate"></p-sortIcon>
                      </span>
                      <p-columnFilter [hidden]="!showFilters" type="date" field="startDateOldBillRate" display="menu"
                        #filterStartDateOldBillRate [showAddButton]="showAddRuleButtonSCR" [showOperator]="false"
                        [matchModeOptions]="matchModeOptionsForDate" [showClearButton]="false"
                        [showApplyButton]="false">
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                          <p-calendar #startDateOldBillRate inputId="navigators" [monthNavigator]="true" [yearNavigator]="true"  yearRange="2000:2030" [ngModel]="value"></p-calendar>
                          <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                            <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger"
                              (onClick)="filter(undefined);applyFilterNew(dt2)">Clear</p-button>
                            <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-success"
                              (onClick)="filter(startDateOldBillRate.value);applyFilterNew(dt2);filterStartDateOldBillRate.hide()">
                              Apply</p-button>
                          </div>
                        </ng-template>
                      </p-columnFilter>
                    </th>
                    <th pResizableColumn *ngIf="isShowColumns('endDateOldBillRate')" [ngStyle]="{'width':setColumnWidth(9)}">End Date of <br />Current Rate <span
                        pSortableColumn="endDateOldBillRate" *ngIf="showSorting">
                        <p-sortIcon field="endDateOldBillRate"></p-sortIcon>
                      </span>
                      <p-columnFilter [hidden]="!showFilters" type="date" field="endDateOldBillRate" display="menu"
                        #filterendDateOldBillRate [showAddButton]="showAddRuleButtonECR" [showOperator]="false"
                        [matchModeOptions]="matchModeOptionsForDate" [showClearButton]="false"
                        [showApplyButton]="false">
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                          <p-calendar #endDateOldBillRate inputId="navigators" [monthNavigator]="true" [yearNavigator]="true"  yearRange="2000:2030" [ngModel]="value"></p-calendar>
                          <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                            <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger"
                              (onClick)="filter(undefined);applyFilterNew(dt2)">Clear</p-button>
                            <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-success"
                              (onClick)="filter(endDateOldBillRate.value);applyFilterNew(dt2);filterendDateOldBillRate.hide()">
                              Apply</p-button>
                          </div>
                        </ng-template>
                      </p-columnFilter>
                    </th> 
                    <th pResizableColumn *ngIf="isShowColumns('description')" [ngStyle]="{'width':setColumnWidth(9)}">Description                      
                    </th>

                    <th pResizableColumn *ngIf="isShowColumns('createdByName')" [ngStyle]="{'width':setColumnWidth(7)}">Created By <span pSortableColumn="createdByName"
                        *ngIf="showSorting">
                        <p-sortIcon field="createdByName"></p-sortIcon>
                      </span>
                      <p-columnFilter [hidden]="!showFilters" field="createdByName" display="menu" #filterCreatedBy
                        [showAddButton]="false" [showMatchModes]="true" [matchModeOptions]="matchModeOptions"
                        [showOperator]="false" [showClearButton]="false" [showApplyButton]="false">
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                          <input #createdByName type="text" value="{{filters?.createdByName[0]?.value}}" pInputText
                            class="pinputHeight">
                          <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                            <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger"
                              (onClick)="filter(undefined);applyFilterNew(dt2)">Clear</p-button>
                            <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-success"
                              (onClick)="filter(createdByName.value);applyFilterNew(dt2);filterCreatedBy.hide()">Apply
                            </p-button>
                          </div>
                        </ng-template>
                      </p-columnFilter>
                    </th>

                    <th pResizableColumn *ngIf="isShowColumns('createdOn')" [ngStyle]="{'width':setColumnWidth(7)}">Created On <span pSortableColumn="createdOn"
                        *ngIf="showSorting">
                        <p-sortIcon field="createdOn"></p-sortIcon>
                      </span>
                      <p-columnFilter [hidden]="!showFilters" type="date" field="createdOn" display="menu"
                        #filterCreatedOn [showAddButton]="showAddRuleButtonCON" [showOperator]="false"
                        [matchModeOptions]="matchModeOptionsForDate" [showClearButton]="false"
                        [showApplyButton]="false">
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                          <p-calendar #createdOn inputId="navigators" [monthNavigator]="true" [yearNavigator]="true"  yearRange="2000:2030" [ngModel]="value"></p-calendar>
                          <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                            <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger"
                              (onClick)="filter(undefined);applyFilterNew(dt2)">Clear</p-button>
                            <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-success"
                              (onClick)="filter(createdOn.value);applyFilterNew(dt2);filterCreatedOn.hide()">Apply
                            </p-button>
                          </div>
                        </ng-template>
                      </p-columnFilter>
                    </th>
                    <th pResizableColumn *ngIf="isShowColumns('modifiedByName')" [ngStyle]="{'width':setColumnWidth(7)}">Modified By <span
                        pSortableColumn="modifiedByName" *ngIf="showSorting">
                        <p-sortIcon field="modifiedByName"></p-sortIcon>
                      </span>
                      <p-columnFilter [hidden]="!showFilters" field="modifiedByName" display="menu" #filterModifiedBy
                        [showAddButton]="false" [showMatchModes]="true" [matchModeOptions]="matchModeOptions"
                        [showOperator]="false" [showClearButton]="false" [showApplyButton]="false">
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                          <input #modifiedByName type="text" value="{{filters?.modifiedByName[0]?.value}}" pInputText
                            class="pinputHeight">
                          <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                            <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger"
                              (onClick)="filter(undefined);applyFilterNew(dt2)">Clear</p-button>
                            <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-success"
                              (onClick)="filter(modifiedByName.value);applyFilterNew(dt2);filterModifiedBy.hide()">Apply
                            </p-button>
                          </div>
                        </ng-template>
                      </p-columnFilter>
                    </th>

                    <th pResizableColumn *ngIf="isShowColumns('modifiedOn')" [ngStyle]="{'width':setColumnWidth(7)}">Modified On <span
                        pSortableColumn="modifiedOn" *ngIf="showSorting">
                        <p-sortIcon field="modifiedOn"></p-sortIcon>
                      </span>
                      <p-columnFilter [hidden]="!showFilters" type="date" field="modifiedOn" display="menu"
                        #filterModifiedOn [showAddButton]="showAddRuleButtonMON" [showOperator]="false"
                        [matchModeOptions]="matchModeOptionsForDate" [showClearButton]="false"
                        [showApplyButton]="false">
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                          <p-calendar #modifiedOn inputId="navigators" [monthNavigator]="true" [yearNavigator]="true"  yearRange="2000:2030" [ngModel]="value"></p-calendar>
                          <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                            <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger"
                              (onClick)="filter(undefined);applyFilterNew(dt2)">Clear</p-button>
                            <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-success"
                              (onClick)="filter(modifiedOn.value);applyFilterNew(dt2);filterModifiedOn.hide()">Apply
                            </p-button>
                          </div>
                        </ng-template>
                      </p-columnFilter>
                    </th>
                  </tr>
                  <tr *ngIf="showFilters">
                    <th *ngIf="isShowColumns('action')"></th>
                    <th></th>
                    <th *ngIf="isShowColumns('applicantName')">{{filters?.applicantName[0]?.value}}</th>
                    <th *ngIf="isShowColumns('vendorCompanyName')">{{filters?.vendorCompanyName[0]?.value}}</th>
                    <th *ngIf="isShowColumns('clientCompanyName')">{{filters?.clientCompanyName[0]?.value}}</th>
                    <th *ngIf="isShowColumns('currentBillRate')">{{filters?.currentBillRate[0]?.value}}</th>
                    <th *ngIf="isShowColumns('startDateCurrentBillRate')">
                      {{filters?.startDateCurrentBillRate[0]?.value | date:'MM/dd/yyyy'}}
                      <span *ngIf="filters?.startDateCurrentBillRate.length > 1">-</span> {{filters?.startDateCurrentBillRate[1]?.value | date:'MM/dd/yyyy'}}
                    </th>
                    <th *ngIf="isShowColumns('serviceAgreementDate')">
                      {{filters?.serviceAgreementDate[0]?.value | date:'MM/dd/yyyy'}}
                      <span *ngIf="filters?.serviceAgreementDate.length > 1">-</span> {{filters?.serviceAgreementDate[1]?.value | date:'MM/dd/yyyy'}}
                    </th>
                    <th *ngIf="isShowColumns('po')">{{selectedPOStatus}}</th>
                    <th *ngIf="isShowColumns('msa')">{{selectedMSAStatus}}</th>
                    <th *ngIf="isShowColumns('approvalStatusName')">{{selectedStatus}}</th>
                    <th *ngIf="isShowColumns('oldBillRate')">{{filters?.oldBillRate[0]?.value}}</th>
                    <th *ngIf="isShowColumns('startDateOldBillRate')">{{filters?.startDateOldBillRate[0]?.value | date:'MM/dd/yyyy'}}
                      <span *ngIf="filters?.startDateOldBillRate.length > 1">-</span> {{filters?.startDateOldBillRate[1]?.value | date:'MM/dd/yyyy'}}
                    </th>
                    <!-- <th *ngIf="isShowColumns('endDateOldBillRate')">
                      {{filters?.endDateOldBillRate[0]?.value | date:'MM/dd/yyyy'}}</th> -->
                      <th *ngIf="isShowColumns('endDateOldBillRate')">{{filters?.endDateOldBillRate[0]?.value | date:'MM/dd/yyyy'}}
                        <span *ngIf="filters?.endDateOldBillRate.length > 1">-</span> {{filters?.endDateOldBillRate[1]?.value | date:'MM/dd/yyyy'}}
                      </th>
                    <th *ngIf="isShowColumns('description')"></th>
                    <th *ngIf="isShowColumns('createdByName')">{{filters?.createdByName[0]?.value}}</th>
                    <th *ngIf="isShowColumns('createdOn')">{{filters?.createdOn[0]?.value | date:'MM/dd/yyyy'}}
                      <span *ngIf="filters?.createdOn.length > 1">-</span> {{filters?.createdOn[1]?.value | date:'MM/dd/yyyy'}}
                    </th>
                    <th *ngIf="isShowColumns('modifiedByName')">{{filters?.modifiedByName[0]?.value}}</th>
                    <th *ngIf="isShowColumns('modifiedOn')">{{filters?.modifiedOn[0]?.value | date:'MM/dd/yyyy'}}
                      <span *ngIf="filters?.modifiedOn.length > 1">-</span> {{filters?.modifiedOn[1]?.value | date:'MM/dd/yyyy'}}
                    </th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-rateChangeRequestList>
                  <tr>
                    <td *ngIf="isShowColumns('action')">
                      <a [routerLink]="" class="table-icon table-icon-menu"><i class="pi pi-ellipsis-v"
                          (click)="selectedGridMenuItem = rateChangeRequestList; menu.toggle($event)"></i></a>
                      <p-menu #menu [popup]="true" [model]="itemsForReject" appendTo="body"></p-menu>
                    </td>
                   
                    <td *ngIf="isShowColumns('checkbox')">

                      <p-checkbox [value]="rateChangeRequestList" #tableBodyCheckbox
                        (onChange)="selectTableRow(tableBodyCheckbox)" binary="true"
                        [(ngModel)]="rateChangeRequestList.isCheckboxChecked"
                        [disabled]="rateChangeRequestList.statusName==='Rejected'">
                      </p-checkbox>
                    </td>
                    <td *ngIf="isShowColumns('applicantName')"><span>{{rateChangeRequestList.applicantName}}</span></td>
                    <td *ngIf="isShowColumns('vendorCompanyName')">
                      <span>{{rateChangeRequestList.vendorCompanyName}}</span></td>
                      <td *ngIf="isShowColumns('clientCompanyName')">
                        <span>{{rateChangeRequestList.clientCompanyName}}</span></td>
                    <td *ngIf="isShowColumns('currentBillRate')"><span>{{currencyFormat(rateChangeRequestList.currentBillRate)}}</span>
                    </td>
                    <!--<th *ngIf="isShowColumns('isActive')">{{filters?.isActive[0]?.value}}</th>-->
                    <td *ngIf="isShowColumns('startDateCurrentBillRate')">
                      <span>{{rateChangeRequestList.startDateCurrentBillRate | date:'MM/dd/yyyy'}}</span></td>
                      <td *ngIf="isShowColumns('serviceAgreementDate')">
                        <span>{{rateChangeRequestList.serviceAgreementDate | date:'MM/dd/yyyy'}}</span></td>
                        <td *ngIf="isShowColumns('po')">
                          <span
                              *ngIf="(rateChangeRequestList.poFileUrl === null || rateChangeRequestList.poFileUrl === '')">No</span>
                          <span
                              *ngIf="(rateChangeRequestList.poFileUrl != null &&  rateChangeRequestList.poFileUrl != '')"><a
                                  [routerLink]="[]"
                                  (click)="ShowPOUploadFile(rateChangeRequestList.poFileUrl)">Yes</a></span>
                      </td>
                        <td *ngIf="isShowColumns('msa')">
                          <span
                              *ngIf="(rateChangeRequestList.msaFileUrl === null || rateChangeRequestList.msaFileUrl === '')">No</span>
                          <span
                              *ngIf="(rateChangeRequestList.msaFileUrl != null &&  rateChangeRequestList.msaFileUrl != '')"><a
                                  [routerLink]="[]"
                                  (click)="ShowMSAUploadedFile(rateChangeRequestList.msaFileUrl)">Yes</a></span>
                      </td>
                    <td *ngIf="isShowColumns('approvalStatusName')">
                      <span class="customer-badge status-yellow"
                        *ngIf="(rateChangeRequestList.approvalStatusName==='Change Request')">{{rateChangeRequestList.approvalStatusName}}</span>
                      <span class="customer-badge status-green"
                        *ngIf="(rateChangeRequestList.approvalStatusName==='Approved')">{{rateChangeRequestList.approvalStatusName}}</span>
                      <span class="customer-badge status-red"
                        *ngIf="(rateChangeRequestList.approvalStatusName==='Rejected')">{{rateChangeRequestList.approvalStatusName}}</span>

                    </td>
                    <td *ngIf="isShowColumns('oldBillRate')">{{currencyFormat(rateChangeRequestList.oldBillRate)}}</td>
                    <td *ngIf="isShowColumns('startDateOldBillRate')">
                      {{rateChangeRequestList.startDateOldBillRate | date:'MM/dd/yyyy'}} </td>
                    <td *ngIf="isShowColumns('endDateOldBillRate')">
                      {{rateChangeRequestList.endDateOldBillRate | date:'MM/dd/yyyy'}}</td>
                    <td *ngIf="isShowColumns('description')">
                       <a [routerLink]=""
                        (click)="viewRateHistoryNotes(rateChangeRequestList.descriptionToDisplay)">{{(rateChangeRequestList?.description
                        | slice:0:100) + (rateChangeRequestList?.description.length > 100 ? '...' : '')}}</a></td>
                <td *ngIf="(rateChangeRequestList?.description == null)"><a [routerLink]=""
                        (click)="viewRateHistoryNotes(rateChangeRequestList.descriptionToDisplay)">{{rateChangeRequestList?.description
                        }}</a></td>
                    <td *ngIf="isShowColumns('createdByName')"><span>{{rateChangeRequestList.createdByName}}</span></td>
                    <td *ngIf="isShowColumns('createdOn')">
                      <span>{{rateChangeRequestList.createdOn | date:'MM/dd/yyyy'}}</span></td>
                    <td *ngIf="isShowColumns('modifiedByName')"><span>{{rateChangeRequestList.modifiedByName}}</span>
                    </td>
                    <td *ngIf="isShowColumns('modifiedOn')">
                      <span>{{rateChangeRequestList.modifiedOn | date:'MM/dd/yyyy'}}</span></td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td [attr.colspan]="selectedColumns.length">No Data found.</td>
                  </tr>
                </ng-template>
              </p-table>



            </div>
          </div>
          <br>
          <br>
          <br>
          <br>
        </div>
      </div>
    </div>
  </div>
  <p-toast position="bottom-center"></p-toast>

</section>

<p-dialog header="Rate Change Request - Reject Reason" [(visible)]="rejectDialog">
  <div class=" p-mt-2 p-mb-2">
    <span>Note:</span>
    <ul>
      <li>Image size should be less than 2MB</li>
      <li>Only JPG or PNG files are allowed</li>
    </ul>
  </div>
  <div class="card p-m-2 p-p-2">
    <!-- <textarea [rows]="5" [cols]="30" pInputTextarea autoResize="autoResize"></textarea> -->
    <!-- <textarea id="invoiceRejectReason" [(ngModel)]= "invoiceRejectReason" name="invoiceRejectReasonvalidate" required #invoiceRejectReasonvalidate="ngModel" [rows]="5" pInputTextarea style="width: 100%;"></textarea> -->
    <quill-editor [modules]="rejectModules" [formControl]="rejectReasonControl" placeholder="" required></quill-editor>
    <span class="text-danger" *ngIf="rejectReasonControl?.hasError('maxlengthError')">
      Only 5000 characters allowed.
    </span>

    <div class="p-d-flex p-jc-end p-ai-right p-mt-2">
      <button pButton style="height: 30px;" (click)="cancelRejectDialog()" pRipple type="button" label="Cancel"
        class="p-button-sm p-button-info p-ai-center"></button>&nbsp;&nbsp;&nbsp;
      <button pButton style="height: 30px;" [disabled]="!rejectReasonControl.valid || isUploadCompleted"
        (click)="submitRejectDialog()" pRipple type="button" label="Submit"
        class="p-button-sm p-button-info p-ai-center"></button>
    </div>
  </div>
</p-dialog>

<p-dialog [modal]="true" [style]="{width: '50vw'}" [maximizable]="false" [closable]="false" [draggable]="false"
  [resizable]="false" [(visible)]="showValidationErrorMessage">
  <div class="p-fluid">
    <div class="text-center">
      <span class="" style="font-family: Roboto,'system-ui',sans-serif;">{{validationErrorMessage}}</span>
    </div>
    <br>
    <div class="p-mt-2 text-center">
      <button pButton pRipple type="button" (click)="validationErrorOk()" [style]="{'width':'100px','height':'30px'}"
        icon="pi pi-check-circle" label="Ok" class="p-button-sm p-button-info"></button>
    </div>
  </div>
</p-dialog>

<p-dialog header="Description" [(visible)]="RejectRateChangeDescriptionModal" [modal]="true" class="invoice-history-popup"
    [draggable]="false" [resizable]="false">
    <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 col-sm-12 col-md-12 col-lg-12">
            <div class="p-text-normal">
                <div #RejectRateViewDescriptionContainer></div>
            </div>
        </div>
    </div>
</p-dialog>
<p-dialog header="Description" [(visible)]="rateHistoryDescriptionModal" [modal]="true" class="invoice-history-popup"
[draggable]="false" [resizable]="false">
<div class="p-fluid p-formgrid p-grid">
    <div class="p-field p-col-12 col-sm-12 col-md-12 col-lg-12">
        <div class="p-text-normal">
            <div #rateViewDescriptionContainer></div>
        </div>
    </div>
</div>
</p-dialog>
<p-dialog header="Rate History" [(visible)]="applicantAdminRateHistoryModal" [modal]="true"
class="applicant-sub-history-popup" [modal]="true" [style]="{width: '70vw', height:'auto',top:'7px'}"
[draggable]="false" [resizable]="false">
<p-table [value]="applicantRateHistoryList" responsiveLayout="scroll">
  <ng-template pTemplate="header">
    <tr>
      <th style="width: 10rem">Applicant</th>
      <th style="width: 6rem">Rate</th>
      <th style="width: 6rem">Start Date</th>
      <th style="width: 6rem">End Date</th>
      <th style="width: 6rem">Status</th>
      <th style="width: 6rem">Description</th>
      <th style="width: 6rem">Created By</th>
      <th style="width: 6rem">Created On</th>
      <th style="width: 6rem">Modified By</th>
      <th style="width: 6rem">Modified On</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-applicantRateHistoryList>
    <tr>
      <td>{{applicantRateHistoryList?.applicantName}}</td>
      <td>{{currencyFormat(applicantRateHistoryList?.currentBillRate)}}</td>
      <td>
        {{applicantRateHistoryList?.startDateCurrentBillRate | date:'MM/dd/yyyy'}}
      </td>
      <td>                
        <span *ngIf="applicantRateHistoryList.endDateCurrentBillRate != null">{{applicantRateHistoryList?.endDateCurrentBillRate | date:'MM/dd/yyyy'}}</span>
        <span *ngIf="applicantRateHistoryList.endDateCurrentBillRate == null">TBD</span>
      </td>
      <!-- <td>
        {{applicantRateHistoryList?.statusName}}
      </td> -->
      <td>
        <span class="customer-badge status-yellow"
          *ngIf="(applicantRateHistoryList?.statusName ==='Change Request')">{{applicantRateHistoryList?.statusName}}</span>
        <span class="customer-badge status-green"
          *ngIf="(applicantRateHistoryList?.statusName ==='Approved')">{{applicantRateHistoryList?.statusName}}</span>
        <span class="customer-badge status-red"
          *ngIf="(applicantRateHistoryList?.statusName ==='Rejected')">{{applicantRateHistoryList?.statusName}}</span>

      </td>
      <td style="overflow-wrap:break-word;" *ngIf="(applicantRateHistoryList?.notes != null)"><a [routerLink]=""
        (click)="viewRateHistoryNotes(applicantRateHistoryList.notesForDisplay)">{{(applicantRateHistoryList?.notes
        | slice:0:100) + (applicantRateHistoryList?.notes.length > 100 ? '...' : '')}}</a></td>
<td style="overflow-wrap:break-word;" *ngIf="(applicantRateHistoryList?.notes == null)"><a [routerLink]=""
        (click)="viewRateHistoryNotes(applicantRateHistoryList.notesForDisplay)">{{applicantRateHistoryList?.notes
        }}</a></td>
      <td>
        {{applicantRateHistoryList?.createdByName}}
      </td>
      <td>
        {{applicantRateHistoryList?.createdOn | date:'MM/dd/yyyy hh:mm a'}}
      </td>
      <td>
        {{applicantRateHistoryList?.modifiedByName}}
      </td>
      <td>
        {{applicantRateHistoryList?.modifiedOn | date:'MM/dd/yyyy hh:mm a'}}
      </td>
    </tr>
  </ng-template>
</p-table>
</p-dialog>